<template>
  <div
    role="dialog"
    tabindex="-1"
    ref="moreInfoContainer"
    class="
      more-info
      flex-shrink-0
      bg-primary-light
      md:flex md:flex-col
      justify-center
      rounded
      md:h-full
      p-4
      md:px-6 md:py-12
      relative
    "
  >
    <slot />
    <button
      class="
        hidden
        md:block
        absolute
        top-0
        left-0
        p-5
        border-2 border-transparent
        focus:outline-none
      "
      @click="emitClose"
      aria-label="Close"
    >
      <KIcon
        name="keyboard-arrow-left"
        class="w-3 h-3 fill-current text-black-high-emphasis"
      />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent ,  ref, onMounted, nextTick } from 'vue'
import { KIcon } from '@/components'

export default defineComponent({
  name: 'MoreInfo',
  components: { KIcon },
  emits: ['close'],
  setup (props, { emit }) {
    const moreInfoContainer = ref<HTMLElement | null>(null)

    onMounted(() => {
      nextTick(() => {
      const selectedCard: HTMLElement|null = document.querySelector('.selection-card--is-selected')
      selectedCard?.focus()
        setTimeout(() => {
          moreInfoContainer.value?.focus()
        }, 0)
      })
    })

    const emitClose = () => {
      emit('close')
    }
    return {
      emitClose,
      moreInfoContainer 
    }
  }
})
</script>

<style scoped>

body:not(.using-mouse) button:focus {
  @apply border-black-darkest;
}

@screen md {
  .more-info {
    width: 340px;
  }
}
</style>
